import { useNavigate } from "react-router-dom";

/**
 * SeoBreadcrumb — small, full-width strip rendered between the React Header
 * and the embedded flight-search hero on every SEO page (hubs + detail).
 *
 * The list is provided by the backend fragment endpoint as:
 *   [ { label, href? }, ..., { label }   ]  // last item = current page
 */
export default function SeoBreadcrumb({ items }) {
  const navigate = useNavigate();
  if (!Array.isArray(items) || items.length === 0) return null;

  const onClick = (href) => (e) => {
    if (!href) return;
    e.preventDefault();
    navigate(href);
  };

  return (
    <nav
      className="seo-breadcrumb"
      aria-label="Breadcrumb"
      data-testid="seo-breadcrumb"
    >
      <ol className="seo-breadcrumb-list">
        {items.map((it, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={idx} className="seo-breadcrumb-item">
              {it.href && !isLast ? (
                <a
                  href={it.href}
                  onClick={onClick(it.href)}
                  className="seo-breadcrumb-link"
                  data-testid={`seo-breadcrumb-link-${idx}`}
                >
                  {it.label}
                </a>
              ) : (
                <span
                  className="seo-breadcrumb-current"
                  aria-current={isLast ? "page" : undefined}
                  data-testid={`seo-breadcrumb-current-${idx}`}
                >
                  {it.label}
                </span>
              )}
              {!isLast && (
                <span aria-hidden="true" className="seo-breadcrumb-sep">
                  ›
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
